/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPagination = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M13.414 2H7v12h10V5.586L13.414 2zM9 12V4h3.586L15 6.414V12H9zm-2.293 3.707L4.414 18l2.293 2.293-1.414 1.414L1.586 18l3.707-3.707 1.414 1.414zM22.414 18l-3.707-3.707-1.414 1.414L19.586 18l-2.293 2.293 1.414 1.414L22.414 18zM8 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm9-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPagination as Pagination };
